import React from "react";

// core components
import { connect } from 'react-redux'
import PropTypes from "prop-types";
import { bindActionCreators }  from 'redux';

import { getObjects } from "api/actions";

import { withoutAuth, withSearch, withDropzone } from "HOC"

import {
  GET_OBJECTS,
  GET_OBJECTS_SUCCESS,
  GET_OBJECTS_FAILURE
} from '../../constants/ActionTypes'

import './index.css'
import TruncateLine from "components/TruncateLine";

import MainView from './MainView';

class Home extends React.Component {
  state = {
    hoveringOver: null,
    selections: [],
  };

  async componentWillReceiveProps(nextProps) {
    switch (nextProps.type) {
      case GET_OBJECTS:
        this.setState({ loading: true });
        break;
      case GET_OBJECTS_SUCCESS:
        this.setState({ loading: false });
        break;
      case GET_OBJECTS_FAILURE:
        this.setState({ loading: false });
        break;
    }
  }

  render() {
    return (
      <MainView
        {...this.props}
        data={this.state.data}
        loading={this.state.loading}
        page={this.state.page}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  errorMessage: state.errorMessage,
  objects: state.objects,
  type: state.type,
});

const dispatchToProps = (dispatch) => {
  return bindActionCreators({ getObjects }, dispatch)
};


export default connect(mapStateToProps, dispatchToProps)(
  withDropzone(
    Home
  )
)
